import React from "react";
import { API_BASE_URL } from "views/api"

const contact_detail = {
  'bhaktapur_ddc': API_BASE_URL + 'introduction/contact-detail/?administrative_unit=bhaktapur_district',
  'changunarayan_municipality': API_BASE_URL + 'introduction/contact-detail/?administrative_unit=changunarayan',
  'bhaktapur_municipality': API_BASE_URL + 'introduction/contact-detail/?administrative_unit=bhaktapur',
  'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/contact-detail/?administrative_unit=madhyapur_thimi',
  'suryabinayak_municipality': API_BASE_URL + 'introduction/contact-detail/?administrative_unit=suryabinayak',
}

const title_name = {
  'bhaktapur_ddc': 'जिल्ला समन्वय समिति',
  'changunarayan_municipality': 'चाँगुनारायण नगरपालिका',
  'bhaktapur_municipality': 'भक्तपुर नगरपालिका',
  'madhyapur_thimi_municipality': 'मध्यपुर थिमि नगरपालिका',
  'suryabinayak_municipality': 'सूर्यविनायक नगरपालिका',
}

export default function ProductSection(props) {
  const [contact_info, setContactInfo] = React.useState(undefined);
  React.useEffect(() => {
    if (contact_info === undefined) {
      fetch(contact_detail[props.selection || 'bhaktapur_ddc'])
        .then(results => results.json())
        .then(data => {
          setContactInfo(data.results);
        });
    }
  });
  var HtmlToReactParser = require('html-to-react').Parser;
  var htmlToReactParser = new HtmlToReactParser();
  return (
    <div style={{ textAlign: 'left', maxWidth: 400, color: '#fff' }}>
          <h4>{title_name[props.selection]}</h4>
          {
            contact_info && contact_info[0] &&
            <div style={{ fontSize: 'small' }}>
              {!(contact_info[0].location == "" || contact_info[0].location == null || contact_info[0].location == undefined) &&
                <div>सम्पर्क ठेगाना: {contact_info[0].location}</div>}
              {!(contact_info[0].contact_number == "" || contact_info[0].contact_number == null || contact_info[0].contact_number == undefined) &&
                <div>सम्पर्क फोन: {contact_info[0].contact_number}</div>}
              {!(contact_info[0].email == "" || contact_info[0].email == null || contact_info[0].email == undefined) &&
                <div>ईमेल: {contact_info[0].email}</div>}
              {!(contact_info[0].fax == "" || contact_info[0].fax == null || contact_info[0].fax == undefined) &&
                <div>फ्याक्स्: {contact_info[0].fax}</div>}
              {!(contact_info[0].information_board == "" || contact_info[0].information_board == null || contact_info[0].information_board == undefined) &&
                <div>सूचना वार्ड: {contact_info[0].information_board}</div>}
              {!(contact_info[0].online_newspaper == "" || contact_info[0].online_newspaper == null || contact_info[0].online_newspaper == undefined) &&
                <div>अनलाईन पत्रिका: {contact_info[0].online_newspaper}</div>}
              {!(contact_info[0].information_officer == "" || contact_info[0].information_officer == null || contact_info[0].information_officer == undefined) &&
                <div>सुचना अधिकारी: {contact_info[0].information_officer}</div>}
              {!(contact_info[0].ambulance_contact == "" || contact_info[0].ambulance_contact == null || contact_info[0].ambulance_contact == undefined) &&
                <div>एम्वुलेन्स्: {contact_info[0].ambulance_contact}</div>}
            </div>
          }
    </div>
  );
}
